export const queryKeys = {
  base: ['phone'] as const,
  deviceById: () => [...queryKeys.base, 'deviceById'],
  devicesList: () => [...queryKeys.base, 'devices', 'list'],
  ringtones: () => [...queryKeys.base, 'ringtones'],
  deviceAddressById: () => [...queryKeys.base, 'device', 'e911-address'],
  validateDestroyLine: (id: string) => [...queryKeys.base, 'validate-destroy-line', id],
  unlockProvisioning: () => [...queryKeys.base, 'unlock-provisioning'],
  listExtensions: () => [...queryKeys.base, 'extensions', 'list'],
};
